import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { SESSION_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";

import { changeDateTimeZoneFormat } from "../../services/core/CommonService";
import { post } from "../../services/smartApiService";

interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}

const statusOptions = [
  { value: "started", label: "Started" },
  { value: "active", label: "Active" },
  // { value: "cancel", label: "Cancel" },
  { value: "completed", label: "Completed" },
];

const schema = Yup.object({
  // status: Yup.object()
  //   .shape({ value: Yup.string().required("Status is required") })
  //   .required("Status is required"),
  session_date: Yup.date().required("Session Date is required"),
  session_to_date: Yup.date().required("Session Two Date is required"),
});

const SessionUpdateForm: React.FC<HeaderProps> = ({ dataIn, loadTableData }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      // status: statusOptions.find((o) => o.value === dataIn?.status) || undefined,
      session_date: dataIn?.session_date,
      session_to_date: dataIn?.session_to_date,
    },
  });
  const { closeModal } = useSiteContext();

  const onSubmit = (data: any) => {
    let url = SESSION_URLS.UPDATE_SESSION_DATE;
    data["session_date"] = changeDateTimeZoneFormat(
      data.session_date,
      "DD-MM-YYYY",
    );

    data["session_to_date"] = changeDateTimeZoneFormat(
      data.session_to_date,
      "DD-MM-YYYY",
    );
    let payload = {
      id: dataIn.ID,
      status: data.status?.value,
      session_date: data.session_date,
      session_to_date: data.session_to_date,
    };
    const subscription = post(url, payload).subscribe(() => {
      //console.log("response form ", response.data);
      closeModal();
      loadTableData();
    });
    return () => {
      subscription.unsubscribe();
    };
  };
  const sessionDate = watch("session_date");


  const elements: SdsFormElementProps[] = [
 
    {
      type: "DATE",
      width: 6,
      name: "session_date",
      element: {
        label: "Session Date",
        isRequired: true,
        placeHolder: "Select Date",
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "DATE",
      width: 6,
      name: "session_to_date",
      element: {
        label: "Session Day Two Date",
        isRequired: true,
        placeHolder: "Select Date",
        inputType: "BORDER_LABEL",
        minDate: sessionDate || new Date(new Date().setDate(new Date().getDate() - 1))
          .toISOString()
          .split("T")[0],
      },
    },
    //    {
    //   type: "SELECT_BOX",
    //   width: 12,
    //   name: "status",
    //   element: {
    //     label: "Status",
    //     isRequired: true,
    //     inputType: "BORDER_LABEL",
    //     options: statusOptions,
    //   },
    // },
    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="mt-0 mb-6">
        <div
          className="sd-hims-input ml-6 mr-6 mb-6 p-5"
          style={{ overflow: "visible", position: "relative", zIndex: 1050, minHeight: "380px" }}
        >
          <SdsForm elements={elements} errors={errors} control={control} />
        </div>
      </div>
    </>
  );
};

export default SessionUpdateForm;
